var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92493 1.15916C2.46054 0.648337 1.66998 0.610691 1.15916 1.07507C0.648337 1.53946 0.610691 2.33002 1.07507 2.84084L2.92493 1.15916ZM7 7.5L7.92493 8.34084L8.68933 7.5L7.92493 6.65916L7 7.5ZM1.07507 12.1592C0.610691 12.67 0.648337 13.4605 1.15916 13.9249C1.66998 14.3893 2.46054 14.3517 2.92493 13.8408L1.07507 12.1592ZM1.07507 2.84084L6.07507 8.34084L7.92493 6.65916L2.92493 1.15916L1.07507 2.84084ZM6.07507 6.65916L1.07507 12.1592L2.92493 13.8408L7.92493 8.34084L6.07507 6.65916Z",
    fill: "#FF7B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightVector);
export default __webpack_public_path__ + "static/media/RightVector.9e8dc656d5d3f889ae177189605d082f.svg";
export { ForwardRef as ReactComponent };